// extracted by mini-css-extract-plugin
export var cartIcon = "_oj-0";
export var cartIconContainer = "_oj-1";